// AUTOGENERATED - MANUALLY CHANGES WILL BE REVERTED BY THE GENERATOR
// https://etherscan.io/address/0x24a42fD28C976A61Df5D00D0599C34c4f90748c8
export const ADDRESSES_PROVIDER = '0x24a42fD28C976A61Df5D00D0599C34c4f90748c8';

// https://etherscan.io/address/0x3dfd23A6c5E8BbcFc9581d2E864a68feb6a076d3
export const CORE = '0x3dfd23A6c5E8BbcFc9581d2E864a68feb6a076d3';

// https://etherscan.io/address/0x398eC7346DcD622eDc5ae82352F02bE94C62d119
export const POOL = '0x398eC7346DcD622eDc5ae82352F02bE94C62d119';

export const CHAIN_ID = 1;
